import { FormControlLabel, Switch } from "@mui/material";
import { useTenantTranslation } from "src/hooks/formatters";
import { changeLowMemoryVideoMode } from "src/store/slices/settings";
import { useAppDispatch } from "src/store/store";
import { useLowMemoryVideoMode } from "src/hooks/settings";

export const LowMemoryVideoModeToggle = () => {
  const { t } = useTenantTranslation();
  const dispatch = useAppDispatch();
  const lowMemoryVideoMode = useLowMemoryVideoMode();

  return (
    <FormControlLabel
      control={
        <Switch
          onChange={() => {
            dispatch(changeLowMemoryVideoMode(!lowMemoryVideoMode));
          }}
          checked={lowMemoryVideoMode}
        />
      }
      label={t("lowMemoryVideoMode")}
    />
  );
};
